import React from "react";

export const ModalFooterLoader = () => {
	return (
		<div>
			<div className="text-primary d-flex align-items-center">
				<div className="spinner-border " role="status">
					<span className="sr-only"></span>
				</div>
				<div className="mx-2">
					Loading ...
				</div>
				  
			</div>
		</div>
	);
};